import memoize from "lodash/memoize";
import { computed } from "mobx";

import { colors } from "./colors";
import { fonts } from "./fonts";
import getCoreUIStore from "../../stores/core/core-ui-store";

class Et3Theme {
  getThemeData = computed(() => {
    const themeColors = colors;
    const themeFonts = fonts;
    const height = getCoreUIStore().windowHeight.get();
    const width = getCoreUIStore().windowWidth.get();
    const resolutionHeight = 1080;
    const resolutionWidth = 1920;
    const unitY = height / resolutionHeight;
    const unitX = width / resolutionWidth;

    return {
      unitX,
      unitY,

      shadow: { boxShadow: "1px 2px 5px #A8A8A8" },

      colors: {
        ...themeColors
      },
      fonts: {
        ...themeFonts
      },
      getFontType: (type: "LIGHT" | "MEDIUM" | "BOLD") => {
        switch (type) {
          case "LIGHT":
            return "MontserratLight";
          case "MEDIUM":
            return "MontserratMedium";
          case "BOLD":
            return "MontserratBold";
        }
      },
      getFontSize: (size: number) => {
        const valueNeeded = Math.sqrt(size - 5) / 2;
        return `${valueNeeded}vmin`;
      }
    };
  });
}

export const getTheme = memoize(() => {
  return new Et3Theme();
});

export default getTheme;
